import React, { Component } from 'react'

class AddStudent extends Component {
    state = {
        formclass: ""
    }

    addStudentToJSON = (event) => {
        event.preventDefault();
        console.log("submitted")
        this.setState({ formclass: "was-validated" })

        // alert("You are submitting " + this.state.username);

    }
    // goBackPageHandler = () => {
    //     console.log(this.props)
    //     this.props.history.goBack();
    // }
    render() {

        return (
            <div style={{ padding: "10px" }}>

                <form className={this.state.formclass} onSubmit={this.addStudentToJSON}>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card">
                                <div className="card-header bg-primary" style={{ color: "white" }}>Student Details</div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label ><b>First Name</b></label>
                                            <input type="text" className="form-control" id="studentFname" placeholder="Enter First Name"
                                                name="fname" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label ><b>Last Name</b></label>
                                            <input type="text" className="form-control" id="lname" placeholder="Enter Last Name"
                                                name="studentLname" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label><b>Date of Birth</b></label>
                                            <input type="date" className="form-control" id="dobOfstudent" placeholder="" name="fname"
                                                required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label ><b>Gender</b></label><br />
                                                    Male <input type="radio" id="studentGender" name="studentGender" value="Male" required />
                                                    Female <input type="radio" id="studentGender" name="studentGender" value="Female" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label ><b>Email Id</b></label>
                                            <input type="email" className="form-control" id="studentEmail" placeholder="xyz@gmail.com"
                                                name="studentEmail" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label><b>Current Address</b></label>
                                            <input type="text" className="form-control" id="studentCurrrentAddress" placeholder="Current Address"
                                                name="studentCurrrentAddress" required />
                                            <br />
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <input type="text" className="form-control" id="studentCurrentCity" placeholder="City"
                                                        name="studentCurrentCity" required />
                                                </div>
                                                <div className="col-lg-4">
                                                    <input type="text" className="form-control" id="studentCurrentCountry" placeholder="Country"
                                                        name="studentCurrentCountry" required />
                                                </div>
                                                <div className="col-lg-4">
                                                    <input type="text" className="form-control" id="studentCurrentPincode" placeholder="Pincode"
                                                        name="studentCurrentPincode" required />
                                                </div>
                                            </div>
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="custom-control custom-checkbox mb-3">
                                                <input type="checkbox" className="custom-control-input" id="customCheck"
                                                    name="example1" />
                                                <label className="custom-control-label" ><b>Same as
                                                Above</b></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label><b>Permanent Address</b></label>
                                            <input type="text" className="form-control" id="studentParmanetAddress" placeholder="Permanent Address"
                                                name="studentParmanetAddress" required />
                                            <br />
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <input type="text" className="form-control" id="stduentPermanetCity" placeholder="City"
                                                        name="stduentPermanetCity" required />
                                                </div>
                                                <div className="col-lg-4">
                                                    <input type="text" className="form-control" id="stduentPermanetCountry" placeholder="Country"
                                                        name="stduentPermanetCountry" required />
                                                </div>
                                                <div className="col-lg-4">
                                                    <input type="text" className="form-control" id="stduentPermanetPincode" placeholder="Pincode"
                                                        name="stduentPermanetPincode" required />
                                                </div>
                                            </div>
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label ><b>Blood Group(Optional)</b></label>
                                            <input className="form-control" id="studentBlood" placeholder="A+"
                                                name="studentBlood" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label ><b>Username</b></label>
                                            <input className="form-control" id="stduentUserName" placeholder="Enter Username"
                                                name="studentUserName" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label ><b>Password</b></label>
                                            <input type="password" className="form-control" id="studentPwd" placeholder="********"
                                                name="studentPwd" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label><b>Confirm Password</b></label>
                                            <input type="password" className="form-control" id="studentCnfPwd" placeholder="********"
                                                name="studentCnfPwd" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <label ><b>Profile Image</b></label><br />
                                            <label className="file-upload btn btn-primary"><i className="fa fa-upload mr-2"></i>Browse for file ...
                                                <input id="studentProfilePhoto" type="file" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-6">
                            <div className="card">
                                <div className="card-header bg-primary" style={{ color: "white" }}>
                                    School Info
                                         </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label ><b>Date of joining</b></label>
                                            <input type="date" className="form-control" id="studentJoiningDate" placeholder="" name="studentJoiningDate"
                                                required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label ><b>Class</b></label>
                                            <input type="text" className="form-control" id="studentClass" placeholder="Enter Class Name"
                                                name="studentClass" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label ><b>Roll No</b></label>
                                            <input type="text" className="form-control" id="studentRoll" placeholder="Enter Roll No"
                                                name="studentRoll" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <br />
                            <div className="card ">
                                <div className="card-header bg-primary" style={{ color: "white" }}>
                                    Parent Details
                        </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label ><b>First Name</b></label>
                                            <input type="text" className="form-control" id="parentFname" placeholder="Enter First Name"
                                                name="parentFname" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label ><b>Last Name</b></label>
                                            <input type="text" className="form-control" id="parentLname" placeholder="Enter Last Name"
                                                name="parentLname" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">

                                        <div className="form-group col-lg-12">
                                            <label ><b>Gender</b></label><br />
                                    Male <input type="radio" id="parentGenderMale" name="parentGender" value="Male" required />
                                    Female <input type="radio" id="parentGenderFemale" name="parentGender" value="Female" required />
                                    Other <input type="radio" id="parentGenderOther" name="parentGender" value="Female" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label><b>Email Id</b></label>
                                            <input type="email" className="form-control" id="parentEmail" placeholder="xyz@gmail.com"
                                                name="parentEmail" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label ><b>Username</b></label>
                                            <input type="text" className="form-control" id="parentUserName" placeholder="Enter Username"
                                                name="parentUserName" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label ><b>Password</b></label>
                                            <input type="password" className="form-control" id="parentPwd" placeholder="********"
                                                name="parentPwd" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label ><b>Confirm Password</b></label>
                                            <input type="password" className="form-control" id="parentCnfPwd" placeholder="********"
                                                name="parentCnfPwd" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label ><b>Phone No</b></label>
                                            <input type="text" className="form-control" id="parentPhoneNO" placeholder="Enter Phone No"
                                                name="parentPhoneNO" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label><b>Blood Group(Optional)</b></label>
                                            <input type="text" className="form-control" id="parentBlood" placeholder="A+"
                                                name="parentBlood" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <label><b>Profile Image</b></label><br />

                                            <label className="file-upload btn btn-primary"><i className="fa fa-upload mr-2"></i>Browse for file ...
                                                <input id="parentProfilePhoto" type="file" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-lg-12 " style={{ textAlign: "end" }}>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                    <button type="reset" className="btn btn-success">Reset</button>
                                    <button className="btn btn-primary" onClick={this.goBackPageHandler}>Back</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        );
    }
}
export default AddStudent;